<ngx-spinner  bdColor="rgba(128, 128, 128, 0.8)"
              size="default"
              color="#2f9cf2"
              type="line-scale-pulse-out"
              [name]="spinnerName"
              [fullScreen]="false"><p style="color:white">{{spinnerText}}</p></ngx-spinner>

<p-toast position="top-right"></p-toast>

<p-confirmDialog #cd [style]="{width: '600px'}">
  <p-footer>
    <button type="button" pButton accesskey="d" icon="pi-fw fas fa-trash-alt" class="p-button-raised p-button-danger" label="Delete" (click)="cd.accept()"></button>
    <button type="button" pButton icon="pi pi-times" class="p-button-raised p-button-outlined" label="No" (click)="cd.reject()"></button>
  </p-footer>
</p-confirmDialog>

<!-- <div class="section-title">User Role Management</div> -->
<p-toolbar>
  <div class="p-toolbar-group-left">
    <p-breadcrumb [model]="items" class="p-d-none p-d-lg-inline"></p-breadcrumb>
    <span style="padding-top:2px;">
      <button pButton type="button" 
              class="p-button-rounded p-button-text p-button-primary button-icon-bold icon-large" 
              icon="pi pi-fw pi-refresh" 
              (click)="loadRoles()"></button>

      <!-- Display only on bigger than md screens-->
      <span class="p-d-none p-d-md-inline">
        <button pButton type="button" 
                class="p-button p-button-text" 
                label="Create Role" 
                icon="pi-fw fas fa-plus-circle"
                (click)="openRoleForm(null)"></button>

        <button pButton type="button" 
                class="p-button p-button-text" 
                [disabled]="selectedRole === null"
                label="Edit Role" 
                icon="pi-fw fas fa-edit"
                (click)="openRoleForm(selectedRole)"></button>  

        <button pButton type="button" 
                class="p-button p-button-text" 
                [disabled]="selectedRole === null"
                label="Assign User To Role" 
                icon="pi-fw fas fa-plus-circle"
                (click)="assignUser()"></button>

        <button pButton type="button" 
                class="p-button p-button-text" 
                [disabled]="selectedRoleUser === null"
                label="Remove User From Role" 
                icon="pi-fw fas fa-user-times"
                (click)="removeUser()"></button>  
      </span>
      <!-- Display only on smaller than md screens-->
      <span class="p-d-md-none">
        <button pButton type="button" 
                class="p-button-rounded p-button-success" 
                icon="pi-fw fas fa-plus-circle"
                (click)="openRoleForm(null)"></button>

        <button pButton type="button" 
                class="p-button-rounded p-button-success"  
                [disabled]="selectedRole === null"
                icon="pi-fw fas fa-edit"
                (click)="openRoleForm(selectedRole)"></button>  

        <button pButton type="button" 
                class="p-button-rounded p-button-success" 
                [disabled]="selectedRole === null"
                icon="pi-fw fas fa-plus-circle"
                (click)="assignUser()"></button>

        <button pButton type="button" 
                class="p-button-rounded p-button-danger" 
                [disabled]="selectedRoleUser === null"
                icon="pi-fw fas fa-user-times"
                (click)="removeUser()"></button>  
      </span>
    </span>
  </div>

  <div class="p-toolbar-group-right">
    <i class="pi-fw fas fa-user-tag p-mr-4 p-mt-2 p-text-secondary toolbar-badge-icon" pBadge 
       severity="info"
       pTooltip="Total Number of Roles: {{roles.length}}"
       tooltipPosition="left"
       value="{{roles.length}}"></i>

    <i class="pi-fw fas fa-users p-mr-4 p-mt-2 p-text-secondary toolbar-badge-icon" pBadge 
       severity="info"
       pTooltip="Total Number of Users: {{roleUsers.length}}"
       tooltipPosition="left"
       value="{{roleUsers.length}}"></i>

  </div>
</p-toolbar>
<p-splitter [style]="{'height': 'calc(100% - 36px)'}" layout="{{smallScreen ? 'vertical' : 'horizontal'}}" [panelSizes]="[40,60]" [gutterSize]="8">
  <ng-template pTemplate>
    <div style="height: calc(100% - 30px); width:100%">
      <div class="section-title">
        Roles
      </div>
      <ag-grid-angular
          style="width: 100%; height:100%;"
          class="ag-theme-alpine"
          [rowData]="roles"
          [columnDefs]="roleGridHeaders"
          [context]="context"
          rowSelection="single"
          (rowDoubleClicked)='onRoleRowDblClicked($event)'
          (gridReady)="onRoleGridReady($event)"
          (selectionChanged)="onRoleSelectionChanged($event)">
      </ag-grid-angular>
    </div>
  </ng-template>

  <ng-template pTemplate>
    <div style="height: calc(100% - 30px); width:100%">
      <div class="section-title">Users Assigned to {{selectedRole === null ? "Role" : "[" + selectedRole.roleName + "]"}}</div>
      <ag-grid-angular
            style="width: 100%; height:100%;"
            class="ag-theme-alpine"
            [rowData]="roleUsers"
            [columnDefs]="roleUserGridHeaders"
            [context]="context"
            rowSelection="single"
            (gridReady)="onUserGridReady($event)"
            (selectionChanged)="onRoleUserSelectionChanged($event)">
      </ag-grid-angular>
    </div>

  </ng-template>
</p-splitter>
<!-- 
<div *ngIf="isLoggedIn" class="m-0" style="height:calc(100% - 0px);">
  <ngx-spinner bdColor="rgba(128, 128, 128, 0.8)"
               size="medium"
               color="#2f9cf2"
               type="ball-clip-rotate"
               [fullScreen]="true">
    <p style="color: white" > Loading projects... </p>
  </ngx-spinner>

  <div class="row" style="height:100%">
    <div class="col-md-5 pr-0">
      <div class="card">
        <div class="card-header bg-info text-white p-1">
          <div class="float-left mt-1 pl-2 mr-5">
            Roles
          </div>

          <a [routerLink]="" (click)="openRoleForm(null)"
            class="btn btn-info btn-sm mr-2">
            <i class="fas fa-plus-circle fa-lg mr-1"></i> Create Role
          </a>
          <a [routerLink]="" (click)="openRoleForm(selectedRole)"
            [class.disabled]="selectedRole === null"
            class="btn btn-info btn-sm mr-2">
            <i class="fas fa-edit fa-lg mr-1"></i> Edit Role
          </a>
          <a [routerLink]="" (click)="loadRoles()"
             class="btn btn-info btn-sm mr-2">
            <i class="fa fa-refresh fa-1x"></i> Reload
          </a>
          <i *ngIf="roleLoading" class="fa fa-circle-o-notch fa-spin fa-lg fa-fw"></i>
        </div>

        <div class="card-body m-1 p-0 h-100">
          <ag-grid-angular
            style="width: 100%; height:100%;"
            class="ag-theme-alpine"
            [rowData]="roles"
            [columnDefs]="roleGridHeaders"
            [context]="context"
            rowSelection="single"
            (rowDoubleClicked)='onRoleRowDblClicked($event)'
            (gridReady)="onRoleGridReady($event)"
            (selectionChanged)="onRoleSelectionChanged($event)">
          </ag-grid-angular>
        </div>
      </div>
    </div>

    <div class="col-md-7 pl-0">
      <div class="card">
        <div class="card-header bg-info text-white p-1">
          <div class="float-left mt-1 pl-2 mr-5">
            Users
          </div>

          <a [routerLink]="" (click)="assignUser()"
          [class.disabled]="selectedRole === null"
            class="btn btn-info btn-sm mr-2">
            <i class="fas fa-plus-circle fa-lg mr-1"></i> Assign User <span *ngIf="selectedRole !== null"> to {{selectedRole.roleName}}</span>
          </a>
          <a [routerLink]="" (click)="removeUser()"
            [class.disabled]="selectedRoleUser === null"
            class="btn btn-info btn-sm mr-2">
            <i class="fas fa-user-times fa-lg mr-1"></i> 
            Remove User <span *ngIf="selectedRole !== null"> from {{selectedRole.roleName}}</span>
          </a>

          <i *ngIf="userLoading" class="fa fa-circle-o-notch fa-spin fa-lg fa-fw"></i>
        </div>

        <div class="card-body m-1 p-0 h-100">
          <ag-grid-angular
            style="width: 100%; height:100%;"
            class="ag-theme-alpine"
            [rowData]="roleUsers"
            [columnDefs]="roleUserGridHeaders"
            [context]="context"
            rowSelection="single"
            (gridReady)="onUserGridReady($event)"
            (selectionChanged)="onRoleUserSelectionChanged($event)">
          </ag-grid-angular>
        </div>
      </div>
    </div>
  </div>
</div>
 -->

